import { queryFieldConverter } from "../utils/Converte"
import api from "./Api"

export const getAllReviewManageAdminResponse = <T>(reviewManageField: TReviewManageField = defaultFieldListMap) => {
    const { queryFieldListMap, fieldListMap } = queryFieldConverter<TReviewManageKey, EReviewManage>(reviewManageField)
    const query = `query GetAllReviewManageAdminResponse($fieldListMap: JSON) { getAllReviewManageAdminResponse(fieldListMap:$fieldListMap) { ${queryFieldListMap} } }`
    return api.post<IGraphqlResponse<{ getAllReviewManageAdminResponse: T }>>(`/graphql`, { query, variables: { fieldListMap } })
}




















export enum EReviewManage {
    wellnessLectureReviewId = 'wellnessLectureReviewId',
    programReviewId = 'programReviewId',
    memberId = 'memberId',
    memberName = 'memberName',
    programId = 'programId',
    programBookingId = 'programBookingId',
    reservationId = 'reservationId',
    programTitle = 'programTitle',
    wellnessLectureName = 'wellnessLectureName',
    teacherName = 'teacherName',
    rating = 'rating',
    content = 'content',
    targetDateTime = 'targetDateTime',
    imageUrlList = 'imageUrlList',
    isProgram = 'isProgram',
    isPrivate = 'isPrivate',
    createdDate = 'createdDate',
}

const defaultFieldListMap: TReviewManageField = {
    reviewManage: [EReviewManage.wellnessLectureReviewId, EReviewManage.programReviewId, EReviewManage.memberId, EReviewManage.memberName, EReviewManage.programId, EReviewManage.programBookingId, EReviewManage.reservationId, EReviewManage.programTitle, EReviewManage.wellnessLectureName, EReviewManage.teacherName, EReviewManage.rating, EReviewManage.content, EReviewManage.targetDateTime, EReviewManage.imageUrlList, EReviewManage.isProgram, EReviewManage.isPrivate, EReviewManage.createdDate]
}